import React, { Component } from 'react';
import {browserHistory} from 'react-router';
import Navbar from '../components/Navbar.js';

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentSlide: 0,
    }
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  handleBackClick(event) {
    if(this.props.children.props.params.news) {
      browserHistory.push("/news");
    } else if (!this.props.location.query.id) {
      browserHistory.push("/art");
    }  else {
      this.setState({ currentSlide: this.props.location.query.id })
      browserHistory.push("/art/" + this.props.children.props.params.art);
    }
  }

  render() {
    return (
      <div style={{ height:"100%"}}>
        <Navbar { ...this.props}  onClick={this.handleBackClick} />
          {React.cloneElement(this.props.children, {currentSlide: this.state.currentSlide}, {onClick: this.handleBackClick})}
      </div>
    )
  }
};

export default App;



// WEBPACK FOOTER //
// ./src/pages/App.js